// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hour-selector {
  position: relative;
}
.hour-selector summary {
  padding: 14px 12px;
  border: 1px solid #efefef;
  border-radius: 4px;
  color: #575756;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  position: relative;
}
.hour-selector summary .value {
  min-height: 20px;
}
.hour-selector summary .value:empty + .label {
  top: 21px;
  transform: translateY(0);
  font-size: 16px;
}
.hour-selector summary .label {
  position: absolute;
  top: 0;
  left: 13px;
  transform: translateY(-50%);
  background: white;
  transition: 0.3s all;
  font-size: 12px;
  padding-inline: 6px;
  margin-inline: -6px;
}
.hour-selector .inputs {
  box-shadow: 1px 3px 3px 2px rgba(0, 0, 0, 0.2);
}
.hour-selector > div {
  z-index: 11;
  position: absolute;
  top: 100%;
  padding: 10px 12px;
  border: 1px solid #efefef;
  border-radius: 4px;
  background: white;
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: -webkit-fill-available;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/hour-picker-input/hour-picker-input.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AACJ;AACI;EACE,gBAAA;AACN;AAEI;EACE,SAAA;EACA,wBAAA;EACA,eAAA;AAAN;AAGI;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,2BAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AADN;AAKE;EACE,8CAAA;AAHJ;AAME;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AAJJ","sourcesContent":[".hour-selector {\n  position: relative;\n\n  summary {\n    padding: 14px 12px;\n    border: 1px solid #efefef;\n    border-radius: 4px;\n    color: #575756;\n    font-size: 16px;\n    line-height: 20px;\n    display: flex;\n    position: relative;\n\n    .value {\n      min-height: 20px;\n    }\n\n    .value:empty + .label {\n      top: 21px;\n      transform: translateY(0);\n      font-size: 16px;\n    }\n\n    .label {\n      position: absolute;\n      top: 0;\n      left: 13px;\n      transform: translateY(-50%);\n      background: white;\n      transition: 0.3s all;\n      font-size: 12px;\n      padding-inline: 6px;\n      margin-inline: -6px;\n    }\n  }\n\n  .inputs {\n    box-shadow: 1px 3px 3px 2px rgba(0, 0, 0, 0.2);\n  }\n\n  > div {\n    z-index: 11;\n    position: absolute;\n    top: 100%;\n    padding: 10px 12px;\n    border: 1px solid #efefef;\n    border-radius: 4px;\n    background: white;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    width: -webkit-fill-available;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
